import React, { useEffect, useState } from "react";
import "../styles/UichanEffect.css"; 

const symbols = ["♪", "♬", "★", "𝄞", "♩", "💮", "♥", "🚨", "📛", "🚓", "💯"];
const colors = ["#ff69b4", "#ffd700", "#7fffd4", "#ff6347", "#87cefa", "#adff2f", "#dda0dd"];

export default function UichanEffect() {
  const [effects, setEffects] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const id = Date.now() + Math.random();
      const angle = Math.random() * 2 * Math.PI; // ラジアン
      const distance = 100 + Math.random() * 60; // → 100〜160px の範囲で飛ぶ

      const effect = {
        id,
        symbol: symbols[Math.floor(Math.random() * symbols.length)],
        color: colors[Math.floor(Math.random() * colors.length)],
        x: Math.cos(angle) * distance,
        y: Math.sin(angle) * -distance, // 上方向
        rotation: Math.random() * 360,
      };

      setEffects((prev) => [...prev, effect]);

      setTimeout(() => {
        setEffects((prev) => prev.filter((e) => e.id !== id));
      }, 2000);
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="uichan-effect-wrapper">
      {effects.map((effect) => (
        <div
          key={effect.id}
          className="symbol"
          style={{
            color: effect.color,
            transform: `translate(${effect.x}px, ${effect.y}px) rotate(${effect.rotation}deg)`,
          }}
        >
          {effect.symbol}
        </div>
      ))}
    </div>
  );
}
